import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock(_resolveDynamicComponent($props.tag), {
    class: _normalizeClass(["btn", [{
      'rounded-circle': $props.round
    }, {
      'btn-block': $props.block
    }, {
      'btn-wd': $props.wide
    }, {
      'btn-icon btn-fab': $props.icon
    }, {
      [`btn-${$props.type}`]: $props.type && !$props.outline
    }, {
      [`btn-${$props.size}`]: $props.size
    }, {
      [`btn-outline-${$props.type}`]: $props.outline && $props.type
    }, {
      'btn-link': $props.link
    }, {
      disabled: $props.disabled && $props.tag !== 'button'
    }]]),
    type: $props.tag === 'button' ? $props.nativeType : '',
    disabled: $props.disabled || $props.loading,
    onClick: $options.handleClick
  }, {
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "loading", {}, () => [$props.loading ? (_openBlock(), _createElementBlock("i", _hoisted_1)) : _createCommentVNode("", true)], true), _renderSlot(_ctx.$slots, "default", {}, undefined, true)]),
    _: 3
  }, 8, ["type", "disabled", "onClick", "class"]);
}